<template>
  <div class="container-fluid">
    <div class="row fme-new-edit__title fme-montserrat-font">
      <div class="col-md-10">
        <h3>{{ $t(`supervision.crud.page.${crudCurrentPageTitle}`) | textUpperCase }}</h3>
      </div>

      <div class="col-md-2 text-right">
        <BaseButtonEvent :btText="$t('supervision.crud.button.goBack')" btClickType="goBack" btId="newEditeGoBack" btClickValue="" btUrlGoBack="CrudRouteListPage" btCss="btn fme-btn fme-btn-secondary" />
      </div>
    </div>

    <div class="row fme-new-edit__row">
      <div class="col-md-4">
        <BaseInput :inputCurrentValue="routeName" :inputTitle="$t('supervision.crud.form.route.name.title')" :inputPlaceholder="$t('supervision.crud.form.route.name.placeholder')" inputType="text" inputCss="" inputId="input-route-name" @returned-input-value="routeInput('name', $event)" :inputErrorText="$t(routeError.name)" />
      </div>

      <div class="col-md-4">
        <BaseInputAutocomplete :inputCurrentValue="routeRegion.name" :inputTitle="$t('supervision.crud.form.route.region.title')" :inputPlaceholder="$t('supervision.crud.form.route.region.placeholder')" :inputUrl="regionAutocompleteUrl" inputId="input-location-region" @returned-input-autocomplete-value="routeInput('region', $event)" :inputErrorText="$t(routeError.region)" />
      </div>

      <div class="col-md-2">
        <BaseSelect selectId="select-period" :selectValues="selectPeriodItems" selectCss="" :selectCurrentValue="routePeriod" @returnedSelectValue="routeSelect('period', $event)" :selectErrorText="$t(routeError.period)" />
      </div>

      <div class="col-md-2">
        <BaseSelect selectId="select-shift" :selectValues="selectShiftItems" selectCss="" :selectCurrentValue="routeShift" @returnedSelectValue="routeSelect('shift', $event)" :selectErrorText="$t(routeError.shift)" />
      </div>
    </div>

    <div class="row fme-new-edit__row">
      <div class="col-md-12">
        <BaseInput :inputCurrentValue="routeObjective" :inputTitle="$t('supervision.crud.form.route.objective.title')" :inputPlaceholder="$t('supervision.crud.form.route.objective.placeholder')" inputType="text" inputCss="" inputId="input-route-objective" @returned-input-value="routeInput('objective', $event)" :inputErrorText="$t(routeError.objective)" />
      </div>
    </div>

    <div class="row fme-new-edit__row">
      <div class="col-md-6">
        <div class="fme-content__align--bottom">
          <BaseInputAutocomplete inputCurrentValue="" :inputTitle="$t('supervision.crud.form.route.supervisor.title')" :inputPlaceholder="$t('supervision.crud.form.route.supervisor.placeholder')" :inputUrl="supervisorAutocompleteUrl" inputId="input-route-supervisor" @returned-input-autocomplete-value="routeInput('supervisor', $event)" :inputErrorText="$t(routeError.supervisor)" />

          <ul class="fme-unordered-list__ul fme-montserrat-font">
            <li v-for="(item, index) in routeSupervisor" :key="index" >
              {{ item.name }}

              <a @click.prevent="deleteSupervisor(index)" :title="$t('supervision.crud.button.delete')" class="fme-unordered-list__li--trash">
                <font-awesome-icon far icon="trash-alt" class="fme-unordered-list__li--trash-icon" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-md-6">
        <BaseInputAutocomplete inputCurrentValue="" :inputTitle="$t('supervision.crud.form.route.location.title')" :inputPlaceholder="$t('supervision.crud.form.route.location.placeholder')" :inputUrl="locationsAutocompleteUrl" inputId="input-route-location" @returned-input-autocomplete-value="routeInput('location', $event)" :inputErrorText="$t(routeError.location)" />

        <ul class="fme-unordered-list__ul fme-montserrat-font">
          <li v-for="(item, index) in routeLocation" :key="index" >
            <div class="row fme-unordered-list__ul--itens">
              <div class="col-md-6 fme-unordered-list__ul--iten">
                {{ item.name }}
              </div>

              <div class="col-md-3">
                <BaseInput :inputCurrentValue="item.visits_per_journey" inputTitle="" :inputPlaceholder="$t('supervision.crud.form.route.location.visitsPlaceholder')" inputType="number" inputCss="" inputId="input-route-visites-journey" @returned-input-value="routeLocationInput('locationsVisitsJourney', $event, index)" :inputErrorText="item.error ? $t(`${item.error}`) : ''" :inputDecimalNumber="true" />
              </div>

              <div class="col-md-2 fme-unordered-list__ul--iten">
                {{ item.visits_per_month }}

                <a @click.prevent="deleteLocation(index)" :title="$t('supervision.crud.button.delete')" class="fme-unordered-list__li--trash">
                  <font-awesome-icon far icon="trash-alt" class="fme-unordered-list__li--trash-icon" />
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="row fme-new-edit__row--last text-right">
      <div class="col-md-12">
        <button type="button" class="btn fme-btn fme-btn-primary" @click="showModal">{{ $t('supervision.crud.button.save') }}</button>
        <TheModal v-if="isModalVisible" @close="closeModal" @modal-button-selected-value="modalSelectedValue($event)" :modalEnableCloseBt="true" :modalBtOneValue="false" modalBtOneText="NO PRÓXIMO PERÍODO" :modalBtTwoValue="true" modalBtTwoText="Iniciar Agora" modalClass="modal-40-70">
          <h5 slot="header">{{ $t('supervision.crud.form.route.validity.when_validity_starts') }}</h5>
          <p slot="body">{{ $t('supervision.crud.form.route.validity.when_validity_starts_info') }}</p>
        </TheModal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

const BaseInput = () => import('@/components/fragment/input/BaseInput')
const BaseSelect = () => import('@/components/fragment/select/BaseSelect')
const BaseButtonEvent = () => import('@/components/fragment/button/BaseButtonEvent')
const BaseInputAutocomplete = () => import('@/components/fragment/input/BaseInputAutocomplete')
const TheModal = () => import('@/components/fragment/modal/TheModal')

export default {
  name: 'NewPage',
  created () {
    this.clearStore()
    this.changeCrudCurrentPageTitle('route')
  },
  beforeDestroy () {
    this.clearStore()
    this.changeErrors([])
  },
  data () {
    return {
      selectPeriodItems: {
        'default': 'supervision.crud.select.route.period.title',
        'options': [
          { 'name': 'weekly', 'value': 'route.period.weekly' },
          { 'name': 'biweekly', 'value': 'route.period.biweekly' },
          { 'name': 'monthly', 'value': 'route.period.monthly' }
        ]
      },
      selectShiftItems: {
        'default': 'supervision.crud.select.route.shift.title',
        'options': [
          { 'name': 'daytime', 'value': 'route.shift.daytime' },
          { 'name': 'nightly', 'value': 'route.shift.nightly' },
          { 'name': 'anytime', 'value': 'route.shift.anytime' }
        ]
      },
      saveValues: {
        'type': 'sendPost',
        'id': 'btCreateMore',
        'urlGo': process.env.VUE_APP_ROUTES_API,
        'urlBack': 'CrudRouteListPage'
      },
      routeError: {
        'name': '',
        'region': '',
        'period': '',
        'shift': '',
        'objective': '',
        'supervisor': '',
        'checklist': '',
        'location': '',
        'journey': ''
      },
      regionAutocompleteUrl: `${process.env.VUE_APP_REGIONS_API}?fields=id,name&status=active&filters=name.lk.`,
      supervisorAutocompleteUrl: `${process.env.VUE_APP_USERS_API}?fields=id,name&status=active&filters=role.lk.supervisor,name.lk.`,
      checklistAutocompleteUrl: `${process.env.VUE_APP_CHECKLISTS_API}?fields=id,name&status=active&filters=name.lk.`,
      locationsAutocompleteUrl: `${process.env.VUE_APP_LOCATIONS_API}?fields=id,name,visits_per_month&status=active&filters=name.lk.`,
      isModalVisible: false,
      released: true
    }
  },
  props: {
  },
  components: {
    BaseInput,
    BaseSelect,
    BaseButtonEvent,
    BaseInputAutocomplete,
    TheModal
  },
  computed: {
    ...mapGetters(['axiosHeaders1']),
    ...mapGetters('ModuleErrors', [
      'errorsList'
    ]),
    ...mapGetters('ModuleSupervision', [
      'routeNameCrud',
      'routeRegionCrud',
      'routePeriodCrud',
      'routeShiftCrud',
      'routeObjectiveCrud',
      'routeSupervisorCrud',
      'routeChecklistCrud',
      'routeLocationCrud',
      'crudCurrentPageTitle'
    ]),
    routeName () {
      return this.routeNameCrud
    },
    routeRegion () {
      return this.routeRegionCrud
    },
    routePeriod () {
      return this.routePeriodCrud
    },
    routeShift () {
      return this.routeShiftCrud
    },
    routeObjective () {
      return this.routeObjectiveCrud
    },
    routeSupervisor () {
      return this.routeSupervisorCrud
    },
    routeChecklist () {
      return this.routeChecklistCrud
    },
    routeLocation () {
      return this.routeLocationCrud
    },
    newRoute () {
      let newSupervisors = []
      let newChecklists = []
      let newLocations = []

      this.routeSupervisor.forEach((value, index, array) => {
        let newObg = {
          'supervisor_id': value.id
        }

        newSupervisors.push(newObg)
      })

      this.routeChecklist.forEach((value, index, array) => {
        let newObg = {
          'checklist_id': value.id
        }

        newChecklists.push(newObg)
      })

      this.routeLocation.forEach((value, index, array) => {
        let newObg = {
          'location_id': value.id,
          'visits_per_journey': parseInt(value.visits_per_journey, 10)
        }

        newLocations.push(newObg)
      })

      let route = {
        name: this.routeNameCrud,
        period: this.routePeriodCrud,
        shift: this.routeShiftCrud,
        objective: this.routeObjectiveCrud,
        lineups: newSupervisors,
        assignments: newChecklists,
        destinations: newLocations
      }

      if (this.routeRegionCrud.id === null) {
        delete route.region_id
      } else {
        route.region_id = this.routeRegionCrud.id
      }

      return route
    }
  },
  methods: {
    ...mapActions('ModuleErrors', [
      'changeErrors'
    ]),
    ...mapActions('ModuleSupervision', [
      'changeRouteNameCrud',
      'changeRoutePeriodCrud',
      'changeRouteShiftCrud',
      'changeRouteObjectiveCrud',
      'changeNewRouteRegionCrud',
      'clearRouteRegionCrud',
      'changeNewRouteSupervisorCrud',
      'removeRouteSpecificSupervisorCrud',
      'clearRouteSupervisorCrud',
      'changeNewRouteChecklistCrud',
      'removeRouteSpecificChecklistCrud',
      'clearRouteChecklistCrud',
      'changeRouteSpecificLocationCrud',
      'changeNewRouteLocationCrud',
      'changeRouteLocationCrud',
      'removeRouteSpecificLocationCrud',
      'clearRouteLocationCrud',
      'changeCrudCurrentPageTitle'
    ]),
    routeInput (refValue, eventValue) {
      if (refValue === 'name') {
        if (eventValue.includes("'") || eventValue.includes('"')) {
          this.routeError.name = `errors.name.pattern`;
        } else {
          this.routeError.name = '';
        }
        this.changeRouteNameCrud(eventValue)
      } else if (refValue === 'region') {
        this.changeNewRouteRegionCrud(eventValue)
      } else if (refValue === 'objective') {
        this.changeRouteObjectiveCrud(eventValue)
      } else if (refValue === 'supervisor') {
        let supervisorStore = this.routeSupervisorCrud
        if (supervisorStore.length === 0) {
          this.changeNewRouteSupervisorCrud(eventValue)
        } else {
          let itemReturned = supervisorStore.find((value, index, array) => {
            return eventValue.id === parseInt(value.id, 10)
          })

          if (itemReturned === undefined) {
            this.changeNewRouteSupervisorCrud(eventValue)
          }
        }
      } else if (refValue === 'checklist') {
        let checklistStore = this.routeChecklistCrud

        if (checklistStore.length === 0) {
          this.changeNewRouteChecklistCrud(eventValue)
        } else {
          let itemReturned = checklistStore.find((value, index, array) => {
            return eventValue.id === parseInt(value.id, 10)
          })

          if (itemReturned === undefined) {
            this.changeNewRouteChecklistCrud(eventValue)
          }
        }
      } else if (refValue === 'location') {
        let locationStore = this.routeLocationCrud

        if (locationStore.length === 0) {
          if (eventValue.visits_per_month === 0) {
            eventValue.visits_per_journey = 4
          } else {
            eventValue.visits_per_journey = eventValue.visits_per_month
          }

          this.changeNewRouteLocationCrud(eventValue)
        } else {
          let itemReturned = locationStore.find((value, index, array) => {
            return eventValue.id === parseInt(value.id, 10)
          })

          if (itemReturned === undefined) {
            if (eventValue.visits_per_month === 0) {
              eventValue.visits_per_journey = 4
            } else {
              eventValue.visits_per_journey = eventValue.visits_per_month
            }

            this.changeNewRouteLocationCrud(eventValue)
          }
        }
      }
    },
    routeLocationInput (refValue, eventValue, index) {
      if (refValue === 'locationsVisitsJourney') {
        let locationStore = this.routeLocationCrud
        let specificItem = locationStore[index]
        let item = {
          'index': `${index}`,
          'id': `${specificItem.id}`,
          'name': `${specificItem.name}`,
          'visits_per_month': `${specificItem.visits_per_month}`,
          'visits_per_journey': `${eventValue}`
        }

        this.changeRouteSpecificLocationCrud(item)
      }
    },
    routeSelect (refValue, eventValue) {
      if (refValue === 'period') {
        this.changeRoutePeriodCrud(eventValue)
      } else if (refValue === 'shift') {
        this.changeRouteShiftCrud(eventValue)
      }
    },
    clearStore () {
      this.changeRouteNameCrud('')
      this.changeRoutePeriodCrud('')
      this.changeRouteShiftCrud('')
      this.changeRouteObjectiveCrud('')
      this.clearRouteRegionCrud()
      this.clearRouteSupervisorCrud()
      this.clearRouteChecklistCrud()
      this.clearRouteLocationCrud()
    },
    onCountrySelected (item) {
      this.selectedCountry = item
    },
    onSearchItemSelected (item) {
      this.selectedSearchItem = item
    },
    deleteSupervisor (supervisorIndex) {
      this.removeRouteSpecificSupervisorCrud(supervisorIndex)
    },
    deleteChecklist (checklistIndex) {
      this.removeRouteSpecificChecklistCrud(checklistIndex)
    },
    deleteLocation (locationIndex) {
      this.removeRouteSpecificLocationCrud(locationIndex)
    },
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
    modalSelectedValue (value) {
      this.isModalVisible = false
      this.released = value
      let newObg = this.newRoute
      newObg.released_from = value

      axios.post(this.saveValues.urlGo, this.newRoute, {
        headers: this.axiosHeaders1
      })
        .then(response => {
          if (this.saveValues.urlBack !== '') {
            this.$router.push({ name: this.saveValues.urlBack })
          }
        })
        .catch(e => {
          if (e.response.status && e.response.status === 401) {
            this.logoutUser()
          } else {
            this.changeErrors(e.response.data.error)
          }
        })
    }
  },
  filters: {
  },
  watch: {
    errorsList () {
      this.routeError.name = ''
      this.routeError.region = ''
      this.routeError.period = ''
      this.routeError.shift = ''
      this.routeError.objective = ''
      this.routeError.supervisor = ''
      this.routeError.checklist = ''
      this.routeError.location = ''
      this.routeError.journey = ''
      this.routeError.journey = ''

      if (this.hasProperty(this.errorsList, 'message') && this.errorsList.name === 'ForeignKeyViolationError') {
        this.routeError.region = 'errors.regionId.required'
      }

      if (this.hasProperty(this.errorsList.errors, 'name')) {
        this.routeError.name = `errors.name.${this.errorsList.errors.name[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'region_id')) {
        this.routeError.region = `errors.regionId.${this.errorsList.errors.region_id[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'period')) {
        this.routeError.period = `errors.period.${this.errorsList.errors.period[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'shift')) {
        this.routeError.shift = `errors.shift.${this.errorsList.errors.shift[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'objective')) {
        this.routeError.objective = `errors.objective.${this.errorsList.errors.objective[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'supervisor')) {
        this.routeError.supervisor = `errors.supervisorId.${this.errorsList.errors.supervisor[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'checklist')) {
        this.routeError.checklist = `errors.checklist.${this.errorsList.errors.checklist[0].keyword}`
      }

      if (this.hasProperty(this.errorsList.errors, 'location')) {
        this.routeError.location = `errors.locale.${this.errorsList.errors.location[0].keyword}`
      }

      if (this.routeLocation.length > 0) {
        let hasLocationError = false

        for (let i = 0; i < this.routeLocation.length; i++) {
          let itemName = `destinations[${i}].visits_per_journey`
          if (this.hasProperty(this.errorsList.errors, itemName)) {
            if (hasLocationError === false) {
              hasLocationError = true
            }
          }
        }

        if (hasLocationError === true) {
          let locations = this.routeLocation

          for (let i = 0; i < this.routeLocation.length; i++) {
            if (this.routeLocation[i].visits_per_journey < 1) {
              locations[i].error = 'errors.journey.minimum'
            } else {
              locations[i].error = null
            }
          }
          this.clearRouteLocationCrud()
          this.changeRouteLocationCrud(locations)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.fme-unordered-list__ul {
  list-style-type: none;
  padding-left: 14px;
  li {
    padding-top: 14px;
    .fme-unordered-list__ul--itens {
      .fme-unordered-list__ul--iten {
            padding-top: 22px;
      }
    }
  }
}
.fme-unordered-list__li--trash {
  margin-left: 9px;
  cursor:pointer;
  .fme-unordered-list__li--trash-icon {
    color: $fme-color__yale-blue;
  }
}
.fme-new-edit__row--last {
  position: relative;
}
</style>
